/*
 * Animated collage video tiles.
 * Videos are muted, looped and only play while on screen. The marquee plugin
 * clones slides, so new <video> nodes are picked up as they appear.
 * With reduced motion the poster image is shown and nothing plays.
 */
(function () {
	if (window.__aicVideoInit) return;
	window.__aicVideoInit = true;

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (reduceMotion) return;

	var seen = new WeakSet();

	var play = function (video) {
		video.muted = true;
		if (video.preload === 'none') video.preload = 'auto';
		var attempt = video.play();
		if (attempt && attempt.catch) attempt.catch(function () {});
	};

	var observer =
		'IntersectionObserver' in window
			? new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							if (entry.isIntersecting) {
								play(entry.target);
							} else if (!entry.target.paused) {
								entry.target.pause();
							}
						});
					},
					{ rootMargin: '200px 0px' },
				)
			: null;

	var watch = function (root) {
		(root || document).querySelectorAll('video[data-aic-video]').forEach(function (video) {
			if (seen.has(video)) return;
			seen.add(video);
			if (observer) {
				observer.observe(video);
			} else {
				play(video);
			}
		});
	};

	var watchClones = function () {
		document.querySelectorAll('.aic__marquees').forEach(function (wrapper) {
			if (wrapper.__aicVideoObserved) return;
			wrapper.__aicVideoObserved = true;
			new MutationObserver(function () {
				watch(wrapper);
			}).observe(wrapper, { childList: true, subtree: true });
		});
	};

	var init = function () {
		watch();
		watchClones();
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	window.addEventListener('load', init);
	document.addEventListener('shopify:section:load', init);
	document.addEventListener('shopify:section:reorder', init);
})();
